globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Account = appCustomerSpace.Controllers.Account || {};

appCustomerSpace.Controllers.Account.MainController = (function(superClass) {

    utils.extend(MainController, superClass);

    function MainController() {
        return MainController.__super__.constructor.apply(this, arguments);
    }

    $.extend(MainController.prototype, {
        init: function() {
            var _this = this;

            appCustomerSpace.Modules.Account.PlatformIframe.initIframes();

            return MainController.__super__.init.apply(this, arguments);
        }
    });

    return MainController;

})(appCustomerSpace.Controllers.MainController);
